import React from "react";
import { InfoText, InfoImage } from "components/items";
import infoImage02 from "image/infoImage-02.png";
import infoImage03 from "image/infoImage-03.png";
import infoImage04 from "image/infoImage-04.png";

const sectionTitle = [
	{
		text: "다양한 형태의",
		color: "default",
		break: false,
	},
	{
		text: "고체 화장품 ",
		color: "main",
		break: true,
	},
	{
		text: "을 ",
		color: "default",
		break: false,
	},
	{
		text: "생산합니다",
		color: "default",
		break: true,
	},
];

const infoImageObj = [
	{
		id: "infoImage-02",
		style: {
			backgroundImage: `url(${infoImage02})`,
		},
		color: "bgColor-sub",
		text: "Cold Process Soap\n저온숙성 CP비누",
	},
	{
		id: "infoImage-03",
		style: {
			backgroundImage: `url(${infoImage03})`,
		},
		color: "bgColor-sub",
		text: "pH Balanced Soap\n약산성타입 제품",
	},
	{
		id: "infoImage-04",
		style: {
			backgroundImage: `url(${infoImage04})`,
		},
		color: "bgColor-sub",
		text: "Bath Bomb\n입욕제",
	},
];

const drawInfoImage = () => {
	return infoImageObj.map((el) => {
		return <InfoImage obj={el} key={el.id} />;
	});
};

const HomeThreeImageInfo = () => {
	return (
		<section className="HomeThreeImageInfo bgColor-lightGrey">
			<div className="con">
				<InfoText
					title={sectionTitle}
					paragraph="동구밭 팩토리에서는 다양한 형태와 제형의 고체 화장품을 전문으로 만들고 있습니다. 고객의 눈높이에 맞게 함께 고민하고 고객의 니즈에 최적화된 제품을 생산하기 위해 노력하고 있습니다. 경기도 하남시에 위치한 1, 2 공장에 있는 최고의 R&D팀과 생산팀이 고객사와 한 팀이 되어 제품의 기획부터 납품까지 최선을 다합니다."
					btnText="제조 공정보기"
					link={"/service"}
				/>

				<div className="wrap-infoImage">
					<div className="carousel-infoImage">{drawInfoImage()}</div>
					<p className="caption">* 이 외에도 샴푸바,린스바,세탁세제등 다양한 제품을 제조하고 있습니다.</p>
				</div>
			</div>
		</section>
	);
};

export default HomeThreeImageInfo;
